var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warning_",
    "data-name": "Warning ",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_858312",
    "data-name": "Path 858312",
    d: "M23.391,19.386,14.206,3.658a2.2,2.2,0,0,0-3.739,0L1.287,19.386a1.869,1.869,0,0,0,.025,1.971,2.165,2.165,0,0,0,1.845.974H21.522a2.155,2.155,0,0,0,1.825-.965,1.856,1.856,0,0,0,.045-1.957ZM11.489,7.563a.93.93,0,0,1,1.855,0v7.384a.93.93,0,0,1-1.855,0Zm.927,12.216a1.11,1.11,0,1,1,1.19-1.108A1.148,1.148,0,0,1,12.416,19.778Z",
    transform: "translate(0 0)",
    fill: "#f7cd2a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_858313",
    "data-name": "Path 858313",
    d: "M0,0H25V25H0Z",
    fill: "rgba(0,0,0,0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_858314",
    "data-name": "Path 858314",
    d: "M0,0H25V25H0Z",
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.7a805a3c5fb4a812e48a1646421923ba.svg";
export { ForwardRef as ReactComponent };